import React from "react";
import Section from "../components/Section";
import { Checkbox, Radio, Typography } from "payzli-ui";

const CheckboxSection = () => {
	const [state, setState] = React.useState<any>({});
	const handleChange = (event: any) => {
		console.log("event", { [event.target.name]: event.target.checked });
		setState({ ...state, [event.target.name]: event.target.checked });
	};
	const handleClick = (event: any) => {
		console.log("event", { [event.target.value]: event.target.checked });
		setState({ ...state, [event.target.name]: event.target.value });
	};
	return (
		<React.Fragment>
			<Section title={"# Radio buttons"}>
				<div className="d-flex align-items-center  gap2">
					<Radio label="Solid-sm" id="radio1" name="radio" checked={state.radio === "radio1"} onClick={handleClick} value={"radio1"} />
					<Radio label="Outlined-sm" id="radio2" name="radio" checked={state.radio === "radio2"} onClick={handleClick} value={"radio2"} />
				</div>
				<div className="d-flex align-items-center  gap2">
					<Radio
						size="md"
						label="Solid-md"
						id="radio3"
						name="radio"
						checked={state.radio === "radio3"}
						onClick={handleClick}
						value={"radio3"}
					>
						<Typography color="error_primary">Solid md with children typography</Typography>
					</Radio>
					<div className="d-flex">
						<Radio size="md" id="radio4" name="radio" checked={state.radio === "radio4"} onClick={handleClick} value={"radio4"} />
						<Typography color="error_primary">Solid md with custom typography</Typography>
					</div>
				</div>
				<div className="d-flex align-items-center  gap2">
					<Radio
						disabled={true}
						label="disabled-sm unchecked"
						id="radio5"
						name="radio-d"
						checked={false}
						onClick={handleChange}
						value={""}
					/>
					<Radio
						size="md"
						disabled={true}
						label="Disabled-md checked"
						id="radio6"
						name="radio-d"
						checked={true}
						onClick={handleChange}
						value={""}
					/>
				</div>
			</Section>
			<Section title={"# Checkbox"}>
				<div className="d-flex align-items-center  gap2">
					<Checkbox type="solid" label="Solid" id="check7" name="check1" checked={state.check1} onChange={handleChange} />
					<Checkbox type="outline" label="Outlined" id="check8" name="check2" checked={state.check2} onChange={handleChange} />
				</div>

				<div className="d-flex align-items-center gap2">
					<Checkbox
						disabled={true}
						type="solid"
						label="Solid disabled"
						id="check1"
						name="check1"
						checked={state.check1}
						onChange={handleChange}
					/>
					<Checkbox
						disabled={true}
						type="outline"
						label="Outlined disabled"
						id="check2"
						name="check2"
						checked={state.check2}
						onChange={handleChange}
					/>
				</div>
				<div className="divider"></div>
				<div className="d-flex align-items-center gap2">
					<Checkbox
						indeterminate={true}
						type="solid"
						label="Solid"
						id="check1"
						name="check1"
						checked={state.check1}
						onChange={handleChange}
					/>
					<Checkbox
						indeterminate={true}
						type="outline"
						label="Outlined"
						id="check2"
						name="check2"
						checked={state.check2}
						onChange={handleChange}
					/>
				</div>
				<div className="d-flex align-items-center gap2">
					<Checkbox
						indeterminate={true}
						disabled={true}
						type="solid"
						label="Solid disabled"
						id="check1"
						name="check1"
						checked={state.check1}
						onChange={handleChange}
					/>
					<Checkbox
						indeterminate={true}
						disabled={true}
						type="outline"
						label="Outlined disabled"
						id="check2"
						name="check2"
						checked={state.check2}
						onChange={handleChange}
					/>
				</div>
				<div className="d-flex align-items-center gap2">
					<Checkbox type="solid" id="check11" name="check11" checked={state.check11} onChange={handleChange} />
					<Checkbox type="outline" id="check12" name="check12" checked={state.check12} onChange={handleChange} />
					<Checkbox indeterminate={true} type="solid" id="check11" name="check11" checked={state.check11} onChange={handleChange} />
					<Checkbox indeterminate={true} type="outline" id="check12" name="check12" checked={state.check12} onChange={handleChange} />
				</div>
				<div className="divider"></div>
				<div className="d-flex align-items-center  gap2">
					<Checkbox size="md" type="solid" label="Solid-md" id="check7" name="check1" checked={state.check1} onChange={handleChange} />
					<Checkbox size="md" type="outline" label="Outlined-md" id="check8" name="check2" checked={state.check2} onChange={handleChange} />
				</div>
				<div className="d-flex align-items-center  gap2">
					<Checkbox
						indeterminate={true}
						size="md"
						type="solid"
						label="Solid-md"
						id="check7"
						name="check1"
						checked={state.check1}
						onChange={handleChange}
					/>
					<Checkbox
						indeterminate={true}
						size="md"
						type="outline"
						label="Outlined-md"
						id="check8"
						name="check2"
						checked={state.check2}
						onChange={handleChange}
					/>
				</div>
			</Section>
		</React.Fragment>
	);
};

export default CheckboxSection;
